import React, { useState, useEffect } from 'react';

/** Spinner with a rotating message, shown while an embedded page loads. */
export default function LoadingScreen({ title, messages }) {
  const [msgIndex, setMsgIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => setMsgIndex(i => (i + 1) % messages.length), 2500);
    return () => clearInterval(interval);
  }, [messages.length]);

  return (
    <div className="iframe-loader">
      <div className="iframe-loader-spinner">
        <div className="spinner-ring" />
        <div className="spinner-ring spinner-ring-2" />
        <div className="spinner-ring spinner-ring-3" />
      </div>
      <div className="iframe-loader-title">{title}</div>
      <div className="iframe-loader-message">{messages[msgIndex]}</div>
    </div>
  );
}
